module.exports = __webpack_public_path__ + "8f3e070284dfafe7a2e51ea8a8dcf2bf.svg";